import React from "react";
import { useParams } from "react-router-dom";
import SimuladorStripePago from "../components/SimuladorStripePago"; // Ajusta ruta si necesario

function PagoSimulado() {
  const { nombre, email } = useParams(); // Recibido desde la URL

  const handlePagoCompletado = () => {
    alert("✅ Notificación: el pago fue simulado correctamente.");
    // Aquí podrías llamar a un endpoint tipo marcar_introducida.php
  };

  return (
    <SimuladorStripePago
      nombreComercio={decodeURIComponent(nombre)}
      email={decodeURIComponent(email)}
      onPagoCompletado={handlePagoCompletado}
    />
  );
}

export default PagoSimulado;
